import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { ModalService } from '@spartacus/storefront';
import { SdAddCompanyModalComponent } from '../add-company-modal';

@Component({
  selector: 'sd-add-company-button',
  templateUrl: './add-company-button.component.html',
  styleUrls: ['./add-company-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SdAddCompanyButtonComponent {
  @Input() size: 'xs' | 's' = 'xs';
  @Input() action: 'modal' | 'redirect' = 'modal';

  constructor(private modalService: ModalService) {}

  @HostBinding('class')
  get classNames(): string[] {
    return [`button-size-${this.size}`];
  }

  openModal(): void {
    this.modalService.open(SdAddCompanyModalComponent, {
      centered: true,
      size: 'md',
    });
  }
}
